import axios from 'axios';

const client = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_API_MEDIA_GALLERY,
    responseType: 'json'
});

export default client;